import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { IAppOnlyStore } from 'stores/AllStores';
import { UserType } from 'common/interfaces/user';

// Icon
const contactIcon = require('assets/conversation icon.svg');
const companyIcon = require('assets/document profile icon.svg');

// Styles
const s = require('./UserProfile.css');

// Component
@inject('store')
@observer
export class UserProfileInfo extends React.Component<IAppOnlyStore, {}> {
    @computed private get isKnownUserType(): boolean {
        return this.props.store.user.userType === UserType.SalesManager || this.props.store.user.userType === UserType.SalesRep;
    }

    public render() {
        const { user } = this.props.store;

        return (
            <div>

                <div className={s.group}>
                    <img className={s.icon} src={companyIcon} />
                    {(user.name) && (
                        <h1>{user.name}</h1>
                    )}
                    {(this.isKnownUserType) && (
                        <h3>
                            {
                                user.userType === UserType.SalesRep
                                    ? 'SALES REP'
                                    : user.userType === UserType.SalesManager
                                        ? 'SALES MANAGER'
                                        : ''
                            }
                        </h3>
                    )}
                </div>

                <div className={s.group}>
                    <img className={s.icon} src={contactIcon} />
                    <ul>
                        <li>
                            <p>
                                <span>U. {user.username}</span>
                            </p>
                        </li>
                        {(user.email) && (
                            <li>
                                <p className={s.email}>
                                    <span>E. {user.email}</span>
                                </p>
                            </li>
                        )}
                    </ul>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Sidebar/Profile/UserProfileInfo.tsx